import styled from '@emotion/styled';

export const ImageWrapper = styled('div')`
  @media screen and (max-width: 992px) {
    display: none;
  }
`;
export const TextWrapper = styled('div')``;
